import React from "react";
import { Fragment, useState } from "react";
import { Dialog, Menu, Transition, Disclosure } from "@headlessui/react";
import {
  Link,
  Navigate,
  useSearchParams,
  useLocation,
  useParams,
} from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  MenuAlt2Icon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  DocumentIcon,
  TemplateIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  ColorSwatchIcon,
  CogIcon,
  MinusIcon,
  PlusSmIcon as PlusSmIconSolid,
} from "@heroicons/react/solid";
import axios from "axios";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Editcustomermodal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      logoutRedirect: false,
      customer_type_id: "",
      primary_contact_salutation_id: "",
      primary_contact_first_name: "",
      primary_contact_last_name: "",
      company_name: "",
      customer_display_name: "",
      customer_email: "",
      customer_work_phone: "",
      customer_mobile: "",
      designation: "",
      department: "",
      website: "",
      user_id: 11,
      tax_preference_id: "",
      currency_id: null,
      payment_term_id: "",
      gstin_uin: "",
      billing_attention: "",
      billing_country_region: "",
      billing_address_street_one: "",
      billing_address_street_two: "",
      billing_city: "",
      billing_state: "",
      billing_zip_code: "",
      billing_phone: "",
      shipping_attention: "",
      shipping_country_region: "",
      shipping_address_street_one: "",
      shipping_address_street_two: "",
      shipping_city: "",
      shipping_state: "",
      shipping_zip_code: "",
      shipping_phone: "",
      place_of_supply_id: null,
      success: false,
      redirect: false,
      oader: "",
      overLay: "fixed inset-0 bg-black/50 ",
      contactperson: [],
      contactpersondelete: [],
      vehicle_information:[],
      vehicle_information_delete:[],
      error_list: [],
      salutationsList: [],
      cutomerTypelist: [],
      taxprefercenceList: [],
      currencyList: [],
      paymentTerm: [],
      countriesList: [],
      billingstatelist: [],
      shippingstatelist: [],
      placeofSupply: [],
      remark: "",
      editid: this.props.CustomerId,
    };
  }
  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open")
    this.setState({ sidebarOpen: true });
  };

  componentDidMount() {
    this.setLoaderFunction();
    this.state.contactperson = [];
    const token = localStorage.getItem("token");
    //const { id } = this.props.params;
    const { id } = this.state.editid;
    const ress = axios
      .get("public/api/customer/edit/" + this.state.editid, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((ress) => {
        this.state.contactperson = [];
        this.setState({
          customer_type_id: ress.data.customers.customer_type_id,
          primary_contact_salutation_id:
            ress.data.customers.primary_contact_salutation_id,
          primary_contact_first_name:
            ress.data.customers.primary_contact_first_name,
          primary_contact_last_name:
            ress.data.customers.primary_contact_last_name,
          company_name: ress.data.customers.company_name,
          customer_display_name: ress.data.customers.customer_display_name,
          customer_email: ress.data.customers.customer_email,
          customer_work_phone: ress.data.customers.customer_work_phone,
          customer_mobile: ress.data.customers.customer_mobile,
          designation: ress.data.customers.designation,
          department: ress.data.customers.department,
          website: ress.data.customers.website,
          tax_preference_id:
            ress.data.customers.customer_other_detail.tax_preference_id,
          currency_id: ress.data.customers.customer_other_detail.currency_id,
          payment_term_id:
            ress.data.customers.customer_other_detail.payment_term_id,
          gstin_uin: ress.data.customers.customer_other_detail.gstin_uin,
          place_of_supply_id:
            ress.data.customers.customer_other_detail.place_of_supply_id,
          billing_attention:
            ress.data.customers.customer_address.billing_attention,
          billing_country_region:
            ress.data.customers.customer_address.billing_country_region,
          billing_address_street_one:
            ress.data.customers.customer_address.billing_address_street_one,
          billing_address_street_two:
            ress.data.customers.customer_address.billing_address_street_two,
          billing_city: ress.data.customers.customer_address.billing_city,
          billing_state: ress.data.customers.customer_address.billing_state,
          billing_zip_code:
            ress.data.customers.customer_address.billing_zip_code,
          billing_phone: ress.data.customers.customer_address.billing_phone,
          shipping_attention:
            ress.data.customers.customer_address.shipping_attention,
          shipping_country_region:
            ress.data.customers.customer_address.shipping_country_region,
          shipping_address_street_one:
            ress.data.customers.customer_address.shipping_address_street_one,
          shipping_address_street_two:
            ress.data.customers.customer_address.shipping_address_street_two,
          shipping_city: ress.data.customers.customer_address.shipping_city,
          shipping_state: ress.data.customers.customer_address.shipping_state,
          shipping_zip_code:
            ress.data.customers.customer_address.shipping_zip_code,
          shipping_phone: ress.data.customers.customer_address.shipping_phone,
          billingstatelist: ress.data.customers.customer_address.billing_states,
          shippingstatelist:
            ress.data.customers.customer_address.shipping_states,
          remark: ress.data.customers.customer_remark.remark,
          contactperson: ress.data.customers.customer_contact_person,
          vehicle_information:ress.data.customers.vehicle_information,
          error_list: [],
        });
      });
    const res = axios
      .get("public/api/salutations", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ salutationsList: res.data.salutations });
      });

    const res1 = axios
      .get("public/api/taxpreferences", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res1) => {
        this.setState({ taxprefercenceList: res1.data.taxpreferences });
      });

    const res2 = axios
      .get("public/api/currencies", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res2) => {
        this.setState({ currencyList: res2.data.currencies });
      });

    const res3 = axios
      .get("public/api/paymentterms", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res3) => {
        this.setState({ paymentTerm: res3.data.paymentterms });
      });

    const res4 = axios
      .get("public/api/customertypes", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res4) => {
        this.setState({ cutomerTypelist: res4.data.customertypes });
      });

    const res5 = axios
      .get("public/api/countries", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res5) => {
        this.setState({ countriesList: res5.data.countries });
      });

    const res6 = axios
      .get("public/api/customer/place/of/supply", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res6) => {
        this.setState({ placeofSupply: res6.data.place_of_supply });
      });

    setTimeout(
      function () {
        this.closeLoaderFuncion();
      }.bind(this),
      1000
    );
  }

  handleInput = (e) => {
    const token = localStorage.getItem("token");
    if (e.target.name === "shipping_country_region") {
      this.setLoaderFunction();
      this.setState({ loader: "animate-pulse" });
      const res = axios
        .get("public/api/states/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          setTimeout(
            function () {
              this.closeLoaderFuncion();
            }.bind(this),
            1000
          );
          this.setState({ loader: "" });
          this.setState({ shippingstatelist: res.data.states });
        });
    }

    if (e.target.name == "billing_country_region") {
      this.setLoaderFunction();
      const res = axios
        .get("public/api/states/" + e.target.value, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          setTimeout(
            function () {
              this.closeLoaderFuncion();
            }.bind(this),
            1000
          );
          this.setState({ billingstatelist: res.data.states });
        });
    }

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleResponse = (e) => {
    this.props.handleInputFormodal(e);
  };

  updateCustomer = async (e) => {
    this.setLoaderFunction();
    e.preventDefault();

   

    var token = localStorage.getItem("token");
    const headers = {
      authorization: `Bearer ${token}`,
      Accept: "application/json",
    };
    //const { id } = this.props.params;
    const { id } = this.state.editid;
    const res = await axios.post(
      "public/api/customer/update/" + this.state.editid,
      this.state,
      { headers }
    );

    if (res.data.success) {
      this.handleResponse(res.data.success);
      this.closeLoaderFuncion();
      this.setState({ showmsg: true });

      setTimeout(
        function () {
          //Start the timer
          this.setState({ redirect: true }); //After 1 second, set render to true
        }.bind(this),
        1000
      );
    } else {
      this.closeLoaderFuncion();
      this.setState({ error_list: res.data.data });
      //this.setState({ show: true })
    }
  };

  deletecontact = (index) => async (e) => {
    let getId = this.state.contactperson[index]["customer_contact_person_id"];

    if (getId !== undefined) {
      this.state.contactpersondelete.push({
        id: getId,
      });
    }
    this.state.contactperson = this.state.contactperson.filter(
      (s, sidx) => index !== sidx
    );

    this.setState({
      contactperson: this.state.contactperson,
    });
  };

  deletevehicle = (index) => async (e) => {
    let getId = this.state.vehicle_information[index]["id"];

    if (getId !== undefined) {
      this.state.vehicle_information_delete.push({
        id: getId,
      });
    }
    this.state.vehicle_information = this.state.vehicle_information.filter(
      (s, sidx) => index !== sidx
    );

    this.setState({
      vehicle_information: this.state.vehicle_information,
    });
  };
  


  addperson = (e) => {
    this.setState({
      contactperson: this.state.contactperson.concat([
        {
          contact_person_first_name: "",
          contact_person_email_address: "",
          contact_person_mobile: "",
        },
      ]),
    });
  };

  addvehicle = (e) => {
    this.setState({
      vehicle_information: this.state.vehicle_information.concat([
        {
          vehicle_information: "",
        },
      ]),
    });
  };

  handleInputcontactpersonName = (index) => (e) => {
    this.state.contactperson[index].contact_person_first_name = e.target.value;
    this.setState({ contactperson: this.state.contactperson });
  };
  handleInputcontactpersonEmail = (index) => (e) => {
    this.state.contactperson[index].contact_person_email_address =
      e.target.value;
    this.setState({ contactperson: this.state.contactperson });
  };
  handleInputcontactpersonPhone = (index) => (e) => {
    this.state.contactperson[index].contact_person_mobile = e.target.value;
    this.setState({ contactperson: this.state.contactperson });
  };

  handleInputvehicleDetails = (index) => (e) => {
    this.state.vehicle_information[index].vehicle_information = e.target.value;
    this.setState({ vehicle_information: this.state.vehicle_information });
  };
  //Logout function

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  //Logout function
  contactec(error_list,index){
    var pea = `contactperson.${index}.contact_person_email_address`; 
    return error_list[pea];
  }

  
  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      return <Navigate to={"/Customerlist"} />;
    }

    return (
      <>
        {/*
            This example requires updating your template:
    
            ```
            <html class="h-full bg-gray-100">
            <body class="h-full">
            ```
          */}
        <div>
          <div className={this.state.overLay} aria-hidden="true" />

          {/* Static sidebar for desktop */}

          <div className="flex flex-col flex-1">
            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <h1 className="text-2xl font-semibold text-gray-900">
                    Update Customer
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}

                  <div className="hidden sm:block" aria-hidden="true">
                    <div className="py-5">
                      <div className="border-t border-gray-200" />
                    </div>
                  </div>
                  <div className="mt-10 sm:mt-0">
                    <div className="md:grid md:gap-6">
                      <div className="mt-5 md:mt-0 md:col-span-2">
                        <form onSubmit={this.updateCustomer}>
                          <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                              <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="primary_contact_salutation_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Salutation*
                                  </label>
                                  <select
                                    id="primary_contact_salutation_id"
                                    name="primary_contact_salutation_id"
                                    onChange={this.handleInput}
                                    value={
                                      this.state.primary_contact_salutation_id
                                    }
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue={0}
                                  >
                                    <option value="0">------</option>
                                    {this.state.salutationsList.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .primary_contact_salutation_id
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="first-name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    First Name
                                  </label>
                                  <input
                                    type="text"
                                    name="primary_contact_first_name"
                                    id="first-name"
                                    autoComplete="given-name"
                                    onChange={this.handleInput}
                                    value={
                                      this.state.primary_contact_first_name
                                    }
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />

                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .primary_contact_first_name
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="last-name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Last Name
                                  </label>
                                  <input
                                    type="text"
                                    name="primary_contact_last_name"
                                    id="last-name"
                                    autoComplete="family-name"
                                    value={this.state.primary_contact_last_name}
                                    onChange={this.handleInput}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .primary_contact_last_name
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="first-name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Company Name
                                  </label>
                                  <input
                                    type="text"
                                    name="company_name"
                                    id="company_name"
                                    onChange={this.handleInput}
                                    value={this.state.company_name}
                                    autoComplete="given-name"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.company_name}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="customer_display_name"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Customer Display Name
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    name="customer_display_name"
                                    id="customer_display_name"
                                    onChange={this.handleInput}
                                    autoComplete="given-name"
                                    value={this.state.customer_display_name}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .customer_display_name
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="customer_type_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    <span class="after:content-['*'] after:ml-0.5 after:text-red-500 block text-sm font-medium text-slate-700">
                                      Customer Type
                                    </span>
                                  </label>
                                  <select
                                    id="customer_type_id"
                                    name="customer_type_id"
                                    onChange={this.handleInput}
                                    value={this.state.customer_type_id}
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue={0}
                                  >
                                    <option value="">------</option>
                                    {this.state.cutomerTypelist.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.customer_type_id}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="designation"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Designation
                                  </label>
                                  <input
                                    type="text"
                                    name="designation"
                                    id="designation"
                                    onChange={this.handleInput}
                                    autoComplete="designation"
                                    value={this.state.designation}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.designation}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="designation"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Department
                                  </label>
                                  <input
                                    type="text"
                                    name="department"
                                    id="department"
                                    onChange={this.handleInput}
                                    autoComplete="department"
                                    value={this.state.department}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.department}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="customer_mobile"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Customer Phone
                                  </label>
                                  <input
                                    type="number"
                                    name="customer_mobile"
                                    id="customer_mobile"
                                    onChange={this.handleInput}
                                    value={this.state.customer_mobile}
                                    autoComplete="customer_mobile"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.customer_mobile}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="customer_email"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Customer Email
                                  </label>
                                  <input
                                    type="text"
                                    name="customer_email"
                                    id="customer_email"
                                    onChange={this.handleInput}
                                    value={this.state.customer_email}
                                    autoComplete="email"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.customer_email}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="website"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Website
                                  </label>
                                  <input
                                    type="text"
                                    name="website"
                                    id="website"
                                    value={this.state.website}
                                    onChange={this.handleInput}
                                    autoComplete="email"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.website}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                  <div>
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                      Tax Information
                                    </h3>
                                  </div>
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="tax_preference_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Tax Preference
                                  </label>
                                  <select
                                    id="tax_preference_id"
                                    name="tax_preference_id"
                                    onChange={this.handleInput}
                                    value={this.state.tax_preference_id}
                                    autoComplete="taxPreference"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.taxprefercenceList.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.tax_preference_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="currency_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Currency
                                  </label>
                                  <select
                                    id="currency_id"
                                    name="currency_id"
                                    onChange={this.handleInput}
                                    value={this.state.currency_id}
                                    autoComplete="Currience"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="0">------</option>
                                    {this.state.currencyList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.currency_id}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="payment_term_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Payment Terms
                                  </label>
                                  <select
                                    id="payment_term_id"
                                    name="payment_term_id"
                                    onChange={this.handleInput}
                                    value={this.state.payment_term_id}
                                    autoComplete="payment-Terms"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.paymentTerm.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.payment_term_id}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="street-address"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    GSTIN / UIN
                                  </label>
                                  <input
                                    type="text"
                                    name="gstin_uin"
                                    onChange={this.handleInput}
                                    id="gstin"
                                    autoComplete="street-address"
                                    value={this.state.gstin_uin}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.gstin_uin}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="place_of_supply_id"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Place of Supply*
                                  </label>
                                  <select
                                    id="place_of_supply_id"
                                    name="place_of_supply_id"
                                    onChange={this.handleInput}
                                    autoComplete="payment-Terms"
                                    value={this.state.place_of_supply_id}
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.placeofSupply.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.place_of_supply_id}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                  <div>
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                      SHIPPING ADDRESS
                                    </h3>
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="street-address"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Attention
                                  </label>
                                  <input
                                    type="text"
                                    name="shipping_attention"
                                    id="Attention"
                                    onChange={this.handleInput}
                                    autoComplete="street-address"
                                    value={this.state.shipping_attention}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.shipping_attention}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="shipping_country_region"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Country / Region
                                  </label>
                                  <select
                                    id="shipping_country_region"
                                    name="shipping_country_region"
                                    onChange={this.handleInput}
                                    value={this.state.shipping_country_region}
                                    autoComplete="country-name"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.countriesList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {
                                        this.state.error_list
                                          .shipping_country_region
                                      }
                                    </p>
                                  </select>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Address Street 1
                                  </label>
                                  <input
                                    type="text"
                                    name="shipping_address_street_one"
                                    id="Street_address"
                                    onChange={this.handleInput}
                                    autoComplete="address-level2"
                                    value={
                                      this.state.shipping_address_street_one
                                    }
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .shipping_address_street_one
                                    }
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Address Street 2
                                  </label>
                                  <input
                                    type="text"
                                    name="shipping_address_street_two"
                                    id="Street_address2"
                                    onChange={this.handleInput}
                                    autoComplete="address-level2"
                                    value={
                                      this.state.shipping_address_street_two
                                    }
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .shipping_address_street_two
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    City
                                  </label>
                                  <input
                                    type="text"
                                    name="shipping_city"
                                    onChange={this.handleInput}
                                    id="city"
                                    value={this.state.shipping_city}
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.shipping_city}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="region"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    State / Province
                                  </label>

                                  <select
                                    id="state"
                                    name="shipping_state"
                                    onChange={this.handleInput}
                                    value={this.state.shipping_state}
                                    autoComplete="shipping_state"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.shippingstatelist.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {this.state.error_list.shipping_state}
                                    </p>
                                  </select>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="shipping_zip_code"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Zip Code
                                  </label>
                                  <input
                                    type="number"
                                    name="shipping_zip_code"
                                    onChange={this.handleInput}
                                    id="shipping_zip_code"
                                    autoComplete="shipping_zip_code"
                                    value={this.state.shipping_zip_code}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.billing_zip_code}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="shipping_phone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Mobile
                                  </label>
                                  <input
                                    type="number"
                                    name="shipping_phone"
                                    id="shipping_phone"
                                    onChange={this.handleInput}
                                    autoComplete="address-level1"
                                    value={this.state.shipping_phone}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.shipping_phone}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                  <div>
                                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                                      BILLING ADDRESS
                                    </h3>
                                  </div>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="street-address"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Attention
                                  </label>
                                  <input
                                    type="text"
                                    name="billing_attention"
                                    id="Attention"
                                    onChange={this.handleInput}
                                    autoComplete="street-address"
                                    value={this.state.billing_attention}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.billing_attention}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-3">
                                  <label
                                    htmlFor="billing_country_region"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Country / Region
                                  </label>
                                  <select
                                    id="billing_country_region"
                                    name="billing_country_region"
                                    onChange={this.handleInput}
                                    value={this.state.billing_country_region}
                                    autoComplete="country-name"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.countriesList.map((number) => (
                                      <option value={number.id}>
                                        {number.name}
                                      </option>
                                    ))}
                                  </select>
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {
                                      this.state.error_list
                                        .billing_country_region
                                    }
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Address Street 1
                                  </label>
                                  <input
                                    type="text"
                                    name="billing_address_street_one"
                                    id="Street_address"
                                    onChange={this.handleInput}
                                    autoComplete="address-level2"
                                    value={
                                      this.state.billing_address_street_one
                                    }
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.Street_address}
                                  </p>
                                </div>
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Address Street 2
                                  </label>
                                  <input
                                    type="text"
                                    name="billing_address_street_two"
                                    id="Street_address2"
                                    onChange={this.handleInput}
                                    autoComplete="address-level2"
                                    value={
                                      this.state.billing_address_street_two
                                    }
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.Street_address2}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <label
                                    htmlFor="city"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    City
                                  </label>
                                  <input
                                    type="text"
                                    name="billing_city"
                                    onChange={this.handleInput}
                                    value={this.state.billing_city}
                                    id="city"
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.billing_city}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="billing_state"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    State / Province
                                  </label>

                                  <select
                                    id="billing_state"
                                    name="billing_state"
                                    onChange={this.handleInput}
                                    value={this.state.billing_state}
                                    autoComplete="billing_state"
                                    className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  >
                                    <option value="">------</option>
                                    {this.state.billingstatelist.map(
                                      (number) => (
                                        <option value={number.id}>
                                          {number.name}
                                        </option>
                                      )
                                    )}

                                    <p
                                      className="mt-2 text-sm text-red-600"
                                      id="email-error"
                                    >
                                      {this.state.error_list.billing_state}
                                    </p>
                                  </select>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="postal-code"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Zip Code
                                  </label>
                                  <input
                                    type="number"
                                    name="billing_zip_code"
                                    onChange={this.handleInput}
                                    value={this.state.billing_zip_code}
                                    id="postal-code"
                                    autoComplete="postal-code"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.billing_zip_code}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="billing_phone"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Mobile
                                  </label>
                                  <input
                                    type="number"
                                    name="billing_phone"
                                    id="billing_phone"
                                    onChange={this.handleInput}
                                    autoComplete="address-level1"
                                    value={this.state.billing_phone}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.billing_phone}
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                  <label
                                    htmlFor="remark"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                    Remark
                                  </label>
                                  <input
                                    type="text"
                                    name="remark"
                                    id="remark"
                                    onChange={this.handleInput}
                                    autoComplete="address-level1"
                                    value={this.state.remark}
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="email-error"
                                  >
                                    {this.state.error_list.remark}
                                  </p>
                                </div>
                              </div>
                              <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                <div>
                                  <h4 className="text-lg leading-6 font-medium text-gray-900">
                                    Contact Person Details
                                  </h4>
                                </div>
                              </div>
                              <hr />
                              <div className="mt-8">
                                {this.state.contactperson.map(
                                  (person, index) => (
                                    <div className="grid grid-cols-6 gap-6">
                                      <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                        <label
                                          htmlFor="contact_person_first_name"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Name
                                        </label>
                                        <input
                                          type="text"
                                          name="contact_person_first_name"
                                          onChange={this.handleInputcontactpersonName(
                                            index
                                          )}
                                          value={
                                            person.contact_person_first_name
                                          }
                                          id="contact_person_first_name"
                                          autoComplete="address-level2"
                                          className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                        />
                                        <p
                                          className="mt-2 text-sm text-red-600"
                                          id="contact_person_first_name-error"
                                        >
                                          {
                                            this.state.error_list
                                              .contact_person_first_name
                                          }
                                        </p>
                                      </div>
                                      <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                        <label
                                          htmlFor="contact_person_email_address"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Email
                                        </label>
                                        <input
                                          type="text"
                                          name="contact_person_email_address"
                                          onChange={this.handleInputcontactpersonEmail(
                                            index
                                          )}
                                          value={
                                            person.contact_person_email_address
                                          }
                                          id="contact_person_email_address"
                                          autoComplete="address-level2"
                                          className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                        />
                                        <p
                                          className="mt-2 text-sm text-red-600"
                                          id="contact_person_email_address-error"
                                        >
                                           {
                                      
                                              this.contactec(this.state.error_list,index)
                                            
                                          }
                                        </p>
                                      </div>
                                      <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                        <label
                                          htmlFor="contact_person_mobile"
                                          className="block text-sm font-medium text-gray-700"
                                        >
                                          Phone
                                        </label>
                                        <input
                                          type="number"
                                          name="contact_person_mobile"
                                          onChange={this.handleInputcontactpersonPhone(
                                            index
                                          )}
                                          value={person.contact_person_mobile}
                                          id="contact_person_mobile"
                                          autoComplete="address-level2"
                                          className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                        />
                                        <p
                                          className="mt-2 text-sm text-red-600"
                                          id="contact_person_mobile-error"
                                        >
                                          {
                                            this.state.error_list
                                              .contact_person_mobile
                                          }
                                        </p>
                                      </div>

                                      <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                        <button
                                          type="button"
                                          className="mt-8 inline-flex items-center p-.01 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red--700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                          onClick={this.deletecontact(index)}
                                        >
                                          <MinusIcon
                                            className="h-5 w-5"
                                            aria-hidden="true"
                                          />
                                        </button>
                                      </div>
                                    </div>
                                  )
                                )}{" "}
                              </div>
                              <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                  <button
                                    type="button"
                                    className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    onClick={this.addperson}
                                  >
                                    <PlusSmIconSolid
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  </button>
                                </div>
                              </div>

                              <div className="col-span-6 sm:col-span-6 lg:col-span-6 ">
                                <div>
                                  <h4 className="text-lg leading-6 font-medium text-gray-900">
                                  Vehicle Details
                                  </h4>
                                </div>
                              </div>
                              <hr />
                              <div className="mt-8">
                            {this.state.vehicle_information.map((person, index) => (
                              <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                  <label
                                    htmlFor="vehicle_information"
                                    className="block text-sm font-medium text-gray-700"
                                  >
                                   Vehicle Info
                                  </label>
                                  <input
                                    type="text"
                                    name="vehicle_information"
                                    onChange={this.handleInputvehicleDetails(
                                      index
                                    )}
                                    value={person.vehicle_information}
                                    id="vehicle_information"
                                    autoComplete="address-level2"
                                    className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                                  />
                                  <p
                                    className="mt-2 text-sm text-red-600"
                                    id="vehicle_information-error"
                                  > 
                                
                                    { 
                                      
                                    }
                                  </p>
                                </div>

                                <div className="col-span-6 sm:col-span-6 lg:col-span-1">
                                  <button
                                    type="button"
                                    className="mt-8 inline-flex items-center p-.01 border border-transparent rounded-full shadow-sm text-white bg-red-600 hover:bg-red--700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                    onClick={this.deletevehicle(index)}
                                  >
                                    <MinusIcon
                                      className="h-5 w-5"
                                      aria-hidden="true"
                                    />
                                  </button>
                                </div>
                              </div>
                            ))}{" "}
                          </div>
                          <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                              <button
                                type="button"
                                className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                onClick={this.addvehicle}
                              >
                                <PlusSmIconSolid
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>           
                            </div>
                           
                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                              <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
        </div>

        <div
          aria-live="assertive"
          className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
            {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
            <Transition
              show={this.state.showmsg}
              //show={true}
              as={Fragment}
              enter="transform ease-out duration-300 transition"
              enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
              enterTo="translate-y-0 opacity-100 sm:translate-x-0"
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 mt-10">
                <div className="p-4">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <CheckCircleIcon
                        className="h-6 w-6 text-green-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                      <p className="text-sm font-medium text-gray-900">
                        Successfully Saved
                      </p>
                      <p className="mt-1 text-sm text-gray-500"></p>
                    </div>
                    <div className="ml-4 flex-shrink-0 flex">
                      <button
                        className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={() => {
                          this.setState({ showmsg: false });
                        }}
                      >
                        <span className="sr-only">Close</span>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </>
    );
  }
}

export default (props) => <Editcustomermodal {...props} params={useParams()} />;
